import * as React from 'react';

import { Card, TextField, Button, createStyles, WithStyles, Theme, withStyles, Typography } from '@material-ui/core';
import { ChangePassWord } from '../services/main/main.model';

const styles = (theme: Theme) => createStyles({
  container: {
    margin: '20px auto',
    textAlign: 'center',
    maxWidth: 700
  },
  title: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight:700,
    marginTop:15,
    color: theme.palette.primary.main
  },
  cardHeading: {
    padding: 16
  },

});

type Props = {
  onSubmit: (event: object) => void
  onChange: (event: object) => void
  user: ChangePassWord,
} & WithStyles<typeof styles>;
type States = {

};

class ChangePassWordComponent extends React.PureComponent<Props, States> {
  render() {
    const { user, onChange, onSubmit, classes } = this.props;
    return (
      <Card className={classes.container}>
        <form action="/" onSubmit={onSubmit}>
          <Typography className={classes.title} >Đổi mật khẩu</Typography>
          <div className={classes.cardHeading}>
            <TextField
              label="Mật khẩu hiện tại"
              name="currentPassword"
              type="password"
              onChange={onChange}
              value={user.currentPassword}
            />
          </div>

          <div className={classes.cardHeading}>
            <TextField
              label="Mật khẩu mới"
              type="password"
              name="newPassword"
              onChange={onChange}
              value={user.newPassword}
            />
          </div>

          <div className={classes.cardHeading}>
            <TextField
              label="Nhập lại mật khẩu"
              type="password"
              name="repeatPassword"
              onChange={onChange}
              value={user.repeatPassword}
            />
          </div>
          <div className={classes.cardHeading}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
            >
              Đổi mật khẩu
            </Button>
          </div>
        </form>
      </Card>
    );
  }
}

export default withStyles(styles)(ChangePassWordComponent);
